/**
 * @generated SignedSource<<8283f5d9e2abba87f32a12a9779983ae>>
 * @relayHash e7129352ae51d13e5ea7de93087afbc7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b15b04f7754d951061e22c30a58de7ba0b36ed3266dbde0565327931733dca90

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  searchWithLastUsedJql?: boolean | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type GroupByDropdownWithSearchQuery$variables = {
  issueSearchInput?: JiraIssueSearchInput | null | undefined;
  nodeId: string;
};
export type GroupByDropdownWithSearchQuery$data = {
  readonly node: {
    readonly __typename: string;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"GroupByDropdownWithSearchRecentlyUsed" | "GroupByDropdownWithSearch_viewSettings">;
  } | null | undefined;
};
export type GroupByDropdownWithSearchQuery = {
  response: GroupByDropdownWithSearchQuery$data;
  variables: GroupByDropdownWithSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nodeId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "nodeId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  {
    "kind": "FragmentSpread",
    "name": "GroupByDropdownWithSearch_viewSettings"
  },
  {
    "kind": "FragmentSpread",
    "name": "GroupByDropdownWithSearchRecentlyUsed"
  }
],
v6 = {
  "kind": "Variable",
  "name": "issueSearchInput",
  "variableName": "issueSearchInput"
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v6/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v9 = {
  "kind": "ScalarField",
  "name": "name"
},
v10 = {
  "kind": "ScalarField",
  "name": "typeKey"
},
v11 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "concreteType": "JiraIssueSearchViewConfigSettings",
        "kind": "LinkedField",
        "name": "viewSettings",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraSpreadsheetGroupByConfig",
            "kind": "LinkedField",
            "name": "groupByConfig",
            "plural": false,
            "selections": [
              {
                "args": (v7/*: any*/),
                "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                "kind": "LinkedField",
                "name": "availableGroupByFieldOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraField",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v7/*: any*/),
                "filters": [
                  "issueSearchInput",
                  "filter"
                ],
                "handle": "connection",
                "key": "RefetchIssueTableGroupByOptionsQuery_availableGroupByFieldOptions",
                "kind": "LinkedHandle",
                "name": "availableGroupByFieldOptions"
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 5
                  },
                  (v6/*: any*/)
                ],
                "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                "kind": "LinkedField",
                "name": "recentlyUsed",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraField",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "JiraSpreadsheetView",
    "abstractKey": "__isJiraSpreadsheetView"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GroupByDropdownWithSearchQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "JiraGroupedListView"
          },
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "JiraListView"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GroupByDropdownWithSearchQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "JiraGroupedListView"
          },
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "JiraListView"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b15b04f7754d951061e22c30a58de7ba0b36ed3266dbde0565327931733dca90",
    "metadata": {},
    "name": "GroupByDropdownWithSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "05c90a5ca066295ac2e0b256630c3e9b";

export default node;
